module.exports = __webpack_public_path__ + "5206b1c24cf076159222236046191594.svg";